// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3667b6e6","732":"668d615f"}[chunkId] + ".chunk.js";
};